import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initPostHog } from "./lib/posthog";
import "./styles/globals.css";

// Initialize PostHog (error reporting only, #828) before React renders,
// mirroring apps/web's init timing. No-ops when VITE_POSTHOG_KEY is unset.
initPostHog();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
